const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../../views/app/Dashboard');
const Websites = () => import(/* webpackChunkName: "websites" */ '../../views/app/Websites');
const Users = () => import(/* webpackChunkName: "websites" */ '../../views/app/Users');
const Reports = () => import(/* webpackChunkName: "websites" */ '../../views/app/Reports');
const Settings = () => import(/* webpackChunkName: "websites" */ '../../views/app/Settings');
const Website = () => import(/* webpackChunkName: "websites" */ '../../views/app/website/Website');
const CpmVideo = () => import(/* webpackChunkName: "websites" */ '../../views/app/CpmVideo');
const AdUnit = () => import(/* webpackChunkName: "websites" */ '../../views/app/website/AdUnit');
const Bidder = () => import(/* webpackChunkName: "websites" */ '../../views/app/website/Bidder');
const Alerts = () => import(/* webpackChunkName: "websites" */ '../../views/app/Alerts');
const Invoices = () => import(/* webpackChunkName: "websites" */ '../../views/app/Invoices');

export default [
    {
        path: '/',
        component: Dashboard,
    },
    {
        path: '/settings',
        component: Settings,
    },

    {
        path: '/reports',
        component: Reports,
    },
    {
        path: '/website',
        component: Websites,
    },

    {
        path: '/users',
        component: Users,
    },
    {
        path: '/gestione-cpm-video',
        component: CpmVideo,
    },
    {
        path: '/alerts',
        component: Alerts,
    },
    {
        path: '/invoices',
        component: Invoices,
    },
    {
        path: '/website/:website',
        component: Website,
    },
    {
        path: '/website/:website/ad_unit/:adUnit',
        component: AdUnit,
    },
    {
        path: '/website/:website/ad_unit/:adUnit/bidder/:bidder',
        component: Bidder,
    },
]
